<template>
<div>
  <div @drop="SubmitPictureOnDrop" ref="drop-area" id="drop-area"> 

  <slot></slot>
</div>
</div>
</template>

<script>

import EventService from "@/services/EventService.js";
import EventBus from '@/services/EventBus.js';

export default {

   props: {
     propertyid: String,
  },

data(){
  return{
      dropArea: null,
      imgList: [],
      imageUrl: "",
      pictureIdList: [],
      picturesbeinguploaded: 0,
      pictureInfo: [],
  }
},

mounted(){
    this.dropArea = this.$refs['drop-area'];

;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
  this.dropArea.addEventListener(eventName, this.preventDefaults, false)
})

;['dragenter', 'dragover'].forEach(eventName => {
  this.dropArea.addEventListener(eventName, this.highlight, false)
})

;['dragleave', 'drop'].forEach(eventName => {
  this.dropArea.addEventListener(eventName, this.unhighlight, false)
})

},
 
  methods: {

     preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
},

 SubmitPictureOnDrop(e) {

        let dt = e.dataTransfer;
        let filesInInput = dt.files;
        
        this.picturesbeinguploaded++;
        
                  if(this.$route.fullPath.includes("tab1")){
             this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
        } else {
        this.$emit("pictureuploadstatusissues", this.picturesbeinguploaded);
        }
        let picturedetailsobject = {
              imageinformation: []
          }; 

        var filesArray = Array.from(filesInInput); 

        for(var i = 0; i < filesArray.length; i++){
          
          var file = filesArray[i];
          
          if (
              file.type != "image/jpeg" &&
              file.type != "image/png" &&
              file.type != "image/gif" &&
              file.type != "image/bmp" &&
              file.type != "image/tif"
            ) {
              this.picturesbeinguploaded = 0;

          if(this.$route.fullPath.includes("tab1")){

                 this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
          } else{
                             this.$emit("pictureuploadstatusissues", this.picturesbeinguploaded);

          }  
         this.$store.dispatch("addNotification", {
                type: "error",
                Message: "This is not a supported file type"
              });
                return;
                  }
               };

        filesArray.forEach(file => {

            const MaxContentLength = 1024 * 1024 * 10;
            
            if (file.size > MaxContentLength) {
              return  this.$store.dispatch("addNotification", {
                          type: "error",
                          Message: "This is not a supported file type"
                      });
            }
                
            var propertyid = this.propertyid != undefined ? this.propertyid : null;

            picturedetailsobject.imageinformation.push({
                contenttype: file.type,
                filename: file.name,
                //should be null for certain picture uploads
                propertyid: this.propertyid
            })
        });

      let presignedurlholder = " presign default";
      let pictureidholder = "";
      let cacheTime = null;

      EventService.GenerateImageObjectSpaceOnAws(picturedetailsobject)
        .then(response => {

            response.data.imageinformationtoreturn.forEach(imgInfoObject => {
              
                this.pictureIdList.push(imgInfoObject.pictureid);
                presignedurlholder = imgInfoObject.presignedurl;
                cacheTime = imgInfoObject.cachetime;

                // here get the file object from the file array which belongs to the picture id of the current
                // id in the API return array of id's
                var file = filesArray.filter( i => i.name == imgInfoObject.oldfilename)[0];

                this.imgList.push(
                  {blob : URL.createObjectURL(file), 
                   pictureid: imgInfoObject.pictureid}
                  );

                if(this.$route.fullPath.includes("tab1")){
                     EventBus.$emit("new-load-dropped", this.imgList);
                } else{
                     EventBus.$emit("new-load-dropped-issues", this.imgList);

                }
              EventService.uploadPictureToAws(
                  presignedurlholder,
                  file,
                  file.type,
                  cacheTime
                ).then(() => {
                      this.pictureInfo = [imgInfoObject, picturedetailsobject]
                  if(this.$route.fullPath.includes("tab1")){
                     this.$emit("picture-id", this.pictureInfo);
                  }else{
                      this.$emit("picture-id-issues", this.pictureInfo);
                  }
                      this.$emit("displaypicturelocally", URL.createObjectURL(file));
                });
            });

            this.picturesbeinguploaded--;

            if(this.$route.fullPath.includes("tab1")){
                  this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
            } else{
                  this.$emit("pictureuploadstatusissues", this.picturesbeinguploaded);
            }
       });
    },


}
}
</script>

<style scoped>

</style>